// Dev-only logger. In production builds, all log methods are no-ops so we never leak
// debug info or runtime errors to end users' consoles.
const IS_DEV = process.env.NODE_ENV !== 'production';

const noop = () => {};

export const logger = {
  log: IS_DEV ? (...args) => console.log(...args) : noop,
  warn: IS_DEV ? (...args) => console.warn(...args) : noop,
  error: IS_DEV ? (...args) => console.error(...args) : noop,
};

export default logger;
